import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNServiceCode } from 'src/app/models/cnservicecode';

@Component({
  selector: 'app-contact-services',
  templateUrl: './contact-services.component.html',
  styleUrls: ['./contact-services.component.scss']
})
export class ContactServicesComponent implements OnInit {

  @Input() codes: CNServiceCode[];
  @Input() mode = 'delete';
  @Output() action: EventEmitter<[action: string, code: CNServiceCode]> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  codeAction(action: [action: string, code: CNServiceCode]): void {
    this.action.emit(action);
  }
}
